import React, { useState, useCallback } from 'react'
import { useAsyncDebounce } from 'react-table'
//import IntlMessages from 'helpers/IntlMessages';
import { useIntl } from "react-intl";
//import { getManageBatchDetails } from 'redux/admin/ManageBatch/action';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce'

const ServerGlobalFilter = ({ setBatchParam, batchParam }) => {

  const [value, setValue] = useState("");

  const onChange = (value) => {
    fetchSearchResults(value);
  }

  const fetchSearchResults = useCallback(
    debounce(async (query) => {
      try {
        setBatchParam((prevBatchParam) => ({ ...prevBatchParam, offset: 0, searchTerm: query }))
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    }, 800),
    []
  );

  //const intl = useIntl();

  return (
    <span>
      <input
        className="form-control"
        value={value || ""}
        onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        //placeholder={intl.formatMessage({ id: 'menu.search1' })}
        placeholder="Search..."
      />
    </span>
  )
}

export default ServerGlobalFilter;
